module.exports = __webpack_public_path__ + "img/card_icon_mantenimiento_catalogo_equipos_hover.9734fff2.svg";